import { TemplateName } from "../types";
import { NewlyNotReportingSingleTemplate } from "./singleTemplate";
/**
 * Newly-not-reporting cover letter: Idaho (SARA Title III Exemption Form)
 */
export class NewlyNotReportingIDTemplate extends NewlyNotReportingSingleTemplate {
    constructor() {
        super(...arguments);
        this.id = TemplateName.NewlyNotReportingID;
    }
    text(params) {
        const { name, address, organizationName, reportingYear } = this.getSingleFacility(params);
        return `To whom it may concern,

As part of our commitment to environmental compliance and community safety, please find the attached SARA Title III Exemption Form for the following facility:

${name}
${address}

This notification is filed by Encamp, Inc. on behalf of ${organizationName}.

This facility was previously a Tier II reporter and is no longer required to submit a Tier II Inventory Report for Reporting Year ${reportingYear}.

Encamp strives to maintain the most up to date information for our submissions. If our current information is incorrect or you have had any updates or changes, please email support@encamp.com and let us know. This will help us ensure that our records are maintained accurately on behalf of our customers.

${this.signature}`;
    }
}
//# sourceMappingURL=id.js.map